import React, { MouseEvent } from "react";
import { AxiosResponse } from "axios";
import {
    TextBox,
    SelectBox,
    RadioGroup,
    LoadPanel,
    Popup,
    ScrollView
} from "devextreme-react";
import { confirm } from "devextreme/ui/dialog";
import ArtistService, { logicAppPostRequest, IdCheckUpdateRequest, IdCheckLatestByContactApiResponse, IdCheckLatestByContactResponse, IdCheckCheckApi } from "../../services/ArtistService";
import moment from "moment";
import {
    TextBoxOnValueChangedEvent,
    SelectBoxOnValueChangedEvent,
    RadioButtonOnSelectionChanged,
    LookUpOnValueChangedEvent,
    onExportingEvent,
} from "../../types/DevExtremeTypes";
import lookupService, { LookupTypeIndexes, LookupTypeItem } from "../../services/LookupService";
import artistProfileUtils, { ContactPageFormData } from "../Artist-Profile/ArtistProfileUtilitise";
import "../../../assets/images/event-UK-image.jpeg";
import { withTranslation, WithTranslation } from "react-i18next";
import sharedUtils from "../grid/sharedUtilities";
import notify from "devextreme/ui/notify";
import LookupTypeListDynamic from "../select/LookupTypeListDynamic";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faXmark, faClipboardList, faArrowUpRightFromSquare } from "@fortawesome/free-solid-svg-icons";
import IdVerificationSessionReviewPopupContent from "../Artist-Profile/IdVerificationSessionReviewPopupContent";
import { Workbook } from "exceljs";
import { exportDataGrid } from "devextreme/excel_exporter";
import { saveAs } from "file-saver";

interface AddContactProps extends WithTranslation {
    history?: any;
    location?: any;
    mode?: string;
    id?: string;
    businessEntityId?: string;
    contactType?: any;
    handlePopUpClose: (isPopupClose: boolean, isEditMode: string) => void;
    handleContact: (isAdded: string) => void;
}

interface AddContactState {
    isEditMode: boolean;
    requestFormData: ContactPageFormData;
    organisationLookUp: LookupTypeItem[];
    companyLookUp: LookupTypeItem[];
    roleLookUp: LookupTypeItem[];
    showChangeEmailPopup: boolean;
    showEmailValidationPopup: boolean;
    email: string;
    loadPanelVisible: boolean;
    contactCreatedDateTime: string;
    userCreatedDateTime: string;
    errorMessage: [];
    IsShowSuccess: boolean;
    IsShowError: boolean;
    yotiSessionStatus: string;
    retryViaApp: boolean;
    yotiPopupVisible: boolean;
    confirmActionPopupVisible: boolean;
    yotiUserViewUrl: string;
    yotiVerificationId: string;
    yotiResolvedContactId: string;
    notepadPopupVisible: boolean;
    idVerificationSessions: any[];
    selectedIdVerificationSessionId: number;
    selectedVerificationDecision: string;
    selectedVerificationReviewerNotes: string;
    selectedVerificationIsActive: boolean;
}

class AddContact extends React.Component<AddContactProps> {
    conversionUtils: sharedUtils;
    lookupService: lookupService;
    artistService: ArtistService;
    utils: artistProfileUtils;
    taxApplicable: LookupTypeItem[];
    state: AddContactState;
    convertedRequestFormData: any;
    constructor(props: AddContactProps) {
        super(props);
        this.conversionUtils = new sharedUtils();        
        this.lookupService = new lookupService();
        this.artistService = new ArtistService();
        this.utils = new artistProfileUtils();
        this.taxApplicable = this.lookupService.getDecisionTypes();
        this.convertedRequestFormData = this.utils.initializeContactPageItem(this.props.contactType);
        this.state = {
            isEditMode: false,
            requestFormData: this.convertedRequestFormData,
            organisationLookUp: [],
            companyLookUp:[],
            roleLookUp: [],
            showChangeEmailPopup: false,
            showEmailValidationPopup: false,
            email: "",
            loadPanelVisible: false,
            contactCreatedDateTime: "",
            userCreatedDateTime: "",
            errorMessage: [],
            IsShowSuccess: false,
            IsShowError: false,
            yotiSessionStatus: "Trigger Yoti Verification",
            retryViaApp: false,
            yotiPopupVisible: false,
            confirmActionPopupVisible: false,
            yotiUserViewUrl: "",
            yotiVerificationId: "",
            yotiResolvedContactId: "",
            notepadPopupVisible: false,
            idVerificationSessions: [],
            selectedIdVerificationSessionId: 0,
            selectedVerificationDecision: "",
            selectedVerificationReviewerNotes: "",
            selectedVerificationIsActive: false,
        };
    }

    componentWillUnmount() {
        window.removeEventListener('message', this.handleYotiMessage);
    }

    componentDidUpdate(_prevProps: AddContactProps, prevState: AddContactState) {
        if (
            this.state.yotiSessionStatus === "Requested" &&
            prevState.yotiSessionStatus !== "Requested" &&
            this.state.retryViaApp !== false
        ) {
            this.setState({ retryViaApp: false });
        }
    }

    componentDidMount() {
        window.addEventListener('message', this.handleYotiMessage);
        this.setState({
            isEditMode: this.props.mode === "edit",
        });
        this.lookupService
            .getLookupByLookupTypeIndex(LookupTypeIndexes.organisationType)
            .then(this.handleSuccessOrganisationTypeLookUp)
            .catch(this.handleError);
        this.lookupService
            .getLookupByLookupTypeIndex(LookupTypeIndexes.userRoleType)
            .then(this.handleSuccessRoleTypeLookUp)
            .catch(this.handleError);
        this.lookupService
            .getLookupByLookupTypeIndex(LookupTypeIndexes.contactCompanyType)
            .then(this.handleSuccessCompanyLookUp)
            .catch(this.handleError);
        if(this.props.businessEntityId){    
            this.artistService
                .getContactPageDataById(parseInt(this.props.businessEntityId))
                .then(this.handleSuccessContactViewPage)
                .catch((err) => {
                    this.setState({
                        errorMessage: err.response !== null ? JSON.parse(JSON.stringify(err.response.data.error)) : null, // For capturing response at the time of exception and showing error message
                        loadPanelVisible: false,
                        IsShowError: true,
                        IsShowSuccess: false,
                    });
                })
                .finally(() => {
                    this.setState({
                        loadPanelVisible: false,
                    });
                });
        }        
    }

    handleSuccessContactViewPage = (response: AxiosResponse<any>) => {
        // Convert to proper data types
        let contactCreatedDateTime = "";
        let userCreatedDateTime = "";
        var viewDataSource = this.utils.convertContactProfileResponeToFormData(response.data.data);
        const idVerificationCheckResultId = viewDataSource.idVerificationCheckResultId || null;
        this.setState(
            {
                requestFormData: viewDataSource,
                yotiSessionStatus: this.mapCheckResultIdToYotiStatus(idVerificationCheckResultId),
                retryViaApp: (idVerificationCheckResultId || "").toString() === "6",
            } , () => {
                contactCreatedDateTime = this.contactLastUpdatedDisplay(this.state.requestFormData.lastUpdatedOn, true);
                userCreatedDateTime = this.contactLastUpdatedDisplay(this.state.requestFormData.user.lastUpdatedOn, true);
                this.setState({
                    contactCreatedDateTime,
                    userCreatedDateTime,
                });
        });
    };

    handleError = (error: any) => {
        var respMessage: string = "Get Configuration Text service failed with response: " + JSON.stringify(error);

        if (!this.artistService.traceAsErrorToAppInsights(respMessage)) {
            // AppInsights is not available
            console.error(respMessage);
        }
    };

    handleSuccessOrganisationTypeLookUp = (response: AxiosResponse<any>) => {
        var itemData = response.data.data;
        var organisationTypeLUItem: LookupTypeItem;
        var organisationTypeLUItemArray: LookupTypeItem[];
        organisationTypeLUItemArray = [];
        if (itemData) {
            itemData.map((item: any, uniqueKey: number) => {
                organisationTypeLUItem = {
                    id: item.id,
                    value: item.value,
                    parentMappingId: "0",
                };
                organisationTypeLUItemArray.push(organisationTypeLUItem);
            });
        }

        this.setState({
            organisationLookUp: organisationTypeLUItemArray,
        });
    };

    handleSuccessRoleTypeLookUp = (response: AxiosResponse<any>) => {
        var itemData = response.data.data;
        var roleTypeLUItem: LookupTypeItem;
        var roleTypeLUItemArray: LookupTypeItem[];
        roleTypeLUItemArray = [];
        if (itemData) {
            itemData.map((item: any, uniqueKey: number) => {
                roleTypeLUItem = {
                    id: item.id,
                    value: item.value,
                    parentMappingId: "0",
                };
                roleTypeLUItemArray.push(roleTypeLUItem);
            });
        }

        this.setState({
            roleLookUp: roleTypeLUItemArray,
        });
    };
    handleSuccessCompanyLookUp = (response: AxiosResponse<any>) => {
        var itemData = response.data.data;
        var roleTypeLUItem: LookupTypeItem;
        var companyLUItemArray: LookupTypeItem[];
        companyLUItemArray = [];
        itemData.map((item: any, uniqueKey: number) => {
            roleTypeLUItem = {
                id: item.id,
                value: item.value,
                parentMappingId: "0",
            };
            companyLUItemArray.push(roleTypeLUItem);
        });
        this.setState({
            companyLookUp: companyLUItemArray,
        });
    };
    handleChangeContactName = (dxValue: TextBoxOnValueChangedEvent) => {
        this.setState({
            requestFormData: {
                ...this.state.requestFormData,
                name: dxValue.value,
            },
        });
    };

    handleChangeOrganisationValue = (dxValue: SelectBoxOnValueChangedEvent) => {


        this.setState({
            requestFormData: {
                ...this.state.requestFormData,
                organisationTypeId: dxValue.value,
            },
        });
    };
handleChangeCompanyTypeSelect = (dxValue: SelectBoxOnValueChangedEvent) => {
        this.setState({
            requestFormData: {
                ...this.state.requestFormData,
                businessEntityId: dxValue.value,
            },
        });
    }
    handleContactTypeValue = (dxValueChange: LookUpOnValueChangedEvent) => {
        this.setState({
            requestFormData: {
                ...this.state.requestFormData,
                contactTypeId: dxValueChange.value,
            },
        });
    };

    handleChangeEmail = (dxValue: TextBoxOnValueChangedEvent) => {
        this.setState({
            requestFormData: {
                ...this.state.requestFormData,
                email: dxValue.value,
            },
        });
    };

    handleChangeNewEmail = (dxValue: TextBoxOnValueChangedEvent) => {
        this.setState({email: dxValue.value});
    };

    handleChangeMobile = (dxValue: TextBoxOnValueChangedEvent) => {
        this.setState({
            requestFormData: {
                ...this.state.requestFormData,
                mobile: dxValue.value,
            },
        });
    };

    handleChangeJobTitle = (dxValue: TextBoxOnValueChangedEvent) => {
        this.setState({
            requestFormData: {
                ...this.state.requestFormData,
                jobTitle: dxValue.value,
            },
        });
    };

    handleChangeContactActive = (dxValue: RadioButtonOnSelectionChanged) => {
        this.setState({
            requestFormData: {
                ...this.state.requestFormData,
                active: dxValue.value,
            },
        });
    }
    handleChangeEmailRemittance = (dxValue: RadioButtonOnSelectionChanged) => {
        this.setState({
            requestFormData: {
                ...this.state.requestFormData,
                emailRemittance: dxValue.value,
            },
        });
    }
    handleChangeUserName = (dxValue: TextBoxOnValueChangedEvent) => {
        this.setState({
            requestFormData: {
                ...this.state.requestFormData,
                user: {
                    ...this.state.requestFormData.user,
                    name: dxValue.value,
                },
            },
        });
    };

    handleChangeUserRoleValue = (dxValue: SelectBoxOnValueChangedEvent) => {
        this.setState({
            requestFormData: {
                ...this.state.requestFormData,
                user: {
                    ...this.state.requestFormData.user,
                    userRole: {
                        ...this.state.requestFormData.user.userRole,
                        id: dxValue.value,
                    }                    
                },
            },
        });
    };

    handleChangeUserActive = (dxValue: RadioButtonOnSelectionChanged) => {
        this.setState({
            requestFormData: {
                ...this.state.requestFormData,
                user: {
                    ...this.state.requestFormData.user,
                    active: dxValue.value,
                },
            },
        });
    }

    handleChangeAllowWebApp = (dxValue: RadioButtonOnSelectionChanged) => {
        this.setState({
            requestFormData: {
                ...this.state.requestFormData,
                user: {
                    ...this.state.requestFormData.user,
                    allowWebApp: dxValue.value,
                },
            },
        });
    }

    handleChangeDisallowApp = (dxValue: RadioButtonOnSelectionChanged) => {
        this.setState({
            requestFormData: {
                ...this.state.requestFormData,
                user: {
                    ...this.state.requestFormData.user,
                    disallowApp: dxValue.value,
                },
            },
        });
    }
    handleChangeDisallowPortal = (dxValue: RadioButtonOnSelectionChanged) => {
        this.setState({
            requestFormData: {
                ...this.state.requestFormData,
                user: {
                    ...this.state.requestFormData.user,
                    disallowPortal: dxValue.value,
                },
            },
        });
    }

    handleChangeProviderTypeSelect = (dxValueChange: LookUpOnValueChangedEvent) => {
        this.setState({
            requestFormData: {
                ...this.state.requestFormData,
                businessEntityId: dxValueChange.value,
            },
        });
    }

    handleChangeClientTypeSelect = (dxValueChange: LookUpOnValueChangedEvent) => {
        this.setState({
            requestFormData: {
                ...this.state.requestFormData,
                businessEntityId: dxValueChange.value,
            },
        });
    }

    // handleChangeCompanyTypeSelect = (dxValueChange: LookUpOnValueChangedEvent) => {
    //     this.setState({
    //         requestFormData: {
    //             ...this.state.requestFormData,
    //             businessEntityId: dxValueChange.value,
    //         },
    //     });
    // }

    handleCancelOnClick = () => {
        confirm("<div class='text-center'>Close screen without saving?</div>", "Close").then((hasConfirmed) => {
            if (hasConfirmed) {
                this.props.handlePopUpClose(false, "");
            }
        });
    };

    onSubmit = () => {
        this.setState({
            loadPanelVisible: true,
        });
         
        var profileSubmitRequest = this.utils.convertFormDataToContactProfileRequest(this.state.requestFormData);    
        this.artistService
            .saveContactPageData(profileSubmitRequest)
            .then(this.handleSuccessOnFormSubmit)
            .catch((err) => {
                this.setState({
                    errorMessage: err.response !== null ? JSON.parse(JSON.stringify(err.response.data.error)) : null, // For capturing response at the time of exception and showing error message
                    loadPanelVisible: false,
                    IsShowError: true,
                    IsShowSuccess: false,
                });
                this.topFunction();
            })
            .finally(() => {
                this.setState({
                    loadPanelVisible: false,
                });
            });
    };

    handleSuccessOnFormSubmit = (response: AxiosResponse<any>) => {
        this.setState({
            loadPanelVisible: false,
            IsShowError: false,
            IsShowSuccess: true,
        });
        if(this.state.requestFormData.id == ""){
            this.props.handleContact("true");
        }
        //let id = this.state.requestFormData.id || '';
        let id = response?.data?.data?.id || '';
        //if (id) {
            let postObject: logicAppPostRequest = {
                ContactId: id
            };
            this.artistService.triggerLogicAppForContactSync(postObject);
        //}
        notify({ message: "Thank You! Profile Information Saved Successfully!", width: 300, shading: true, position: "center" }, 'success', 600);
        this.props.handlePopUpClose(false, "");
    };

    topFunction = () => {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    };

    changeEmail = () => {
        if(this.state.requestFormData.email == "" || this.state.requestFormData.email == null){
            this.setState({
                showEmailValidationPopup: true,
            });
        }
        else{
            this.setState({
                showChangeEmailPopup: true,
            });
        }
    };

    hideDetail = () => {
        this.setState({
            showChangeEmailPopup: false,
            showEmailValidationPopup: false,
        })
    }
    hideValidationDetail = () => {
        if(this.state.showChangeEmailPopup == true){
            this.setState({
                showChangeEmailPopup: true,
                showEmailValidationPopup: false,
            })
        }
        else {
            this.setState({
                showChangeEmailPopup: false,
                showEmailValidationPopup: false,
            })
        }
    }

    onConfirm = () => {
        if(this.state.email == "" || this.state.email == null){
            this.setState({
                showEmailValidationPopup: true,
            });
        }
        else{
            this.setState({
                requestFormData: {
                    ...this.state.requestFormData,
                    email: this.state.email,
                    updateEmail: true,
                },
                showChangeEmailPopup: false,
                showEmailValidationPopup: false,
            });
        }         
    }

    onEditButtonClick = () => {        
        this.setState({
            isEditMode: true,
        });
        this.props.handlePopUpClose(true, "editMode");
    };

    contactLastUpdatedDisplay = (date:any, type:boolean) => {
        let finalFormattedDate: string = "";
        if(date !== null && date !== undefined && date !== ""){
            const dateTime = new Date(date);
            const formattedTime = this.conversionUtils.convertDateTimeStringToHHMM(dateTime.toString());
            const stringFormattedDate = this.conversionUtils.convertDateToString(dateTime);
            const formattedDate = type
                ? this.conversionUtils.convertStringToddmmmyyyyForm(stringFormattedDate)
                : stringFormattedDate;
            finalFormattedDate = `${formattedDate} ${formattedTime}`;
        }
        return finalFormattedDate;
    };

    /**
     * Listens for postMessage events from the Yoti iframe.
     * Updates yotiSessionStatus based on the completion outcome reported by Yoti.
     */
    handleYotiMessage = (event: MessageEvent) => {
        if (!this.state.yotiPopupVisible) return;
        const data = event.data;
        if (!data) return;
        const eventType: string = typeof data === 'string' ? data : data.eventType ?? data.type ?? '';
        const normalizedEvent = (eventType || "").toUpperCase();
        const contactId = this.getYotiContactId();

        if (["SUCCESS", "YOTI_IDV_SUCCESS", "COMPLETED"].includes(normalizedEvent)) {
            this.setState({ yotiSessionStatus: "Approved", yotiPopupVisible: false });
            if (contactId) {
                this.loadLatestIdCheckByContactId(contactId, false, false);
            }
            return;
        }

        if (["UNSURE", "YOTI_IDV_REQUIRES_REVIEW", "REQUIRES_REVIEW"].includes(normalizedEvent)) {
            this.setState({ yotiSessionStatus: "Requires Review", yotiPopupVisible: false });
            if (contactId) {
                this.loadLatestIdCheckByContactId(contactId, false, false);
            }
            return;
        }

        if (["ERROR", "YOTI_IDV_ERROR", "FAILED", "REJECTED"].includes(normalizedEvent)) {
            this.setState({ yotiSessionStatus: "Rejected", yotiPopupVisible: false });
            if (contactId) {
                this.loadLatestIdCheckByContactId(contactId, false, false);
            }
        }
    };

    /** Returns the contact ID for use with the Yoti API. */
    getYotiContactId = (): string | null => {
        const uiContactId = (this.state.requestFormData.id || "").toString().trim();
        if (uiContactId) {
            return uiContactId;
        }
        const fallbackContactId = (this.state.yotiResolvedContactId || "").toString().trim();
        return fallbackContactId || null;
    };

    /** Maps idVerificationCheckResultId value to a human-readable Yoti status string. */
    mapCheckResultIdToYotiStatus = (checkResultId: string | null) => {
        const v = (checkResultId || "").toString();
        if (v === "5") return "Requested";
        if (v === "6") return "Retry Via App Requested";
        if (v === "20") return "Approved";
        if (v === "99") return "Rejected";
        if (v === "10") return "Requires Review";
        return "Trigger Yoti Verification";
    };

    getYotiStatusStyles = (status: string) => {
        const normalizedStatus = (status || "").toLowerCase().trim();
        if (normalizedStatus === "rejected" || normalizedStatus === "retry via app request failed") {
            return { backgroundColor: "#FFEFEF", color: "#ff5a5e" };
        }
        if (normalizedStatus === "requires review") {
            return { backgroundColor: "#F9F2E1", color: "#f7b500" };
        }
        if (normalizedStatus === "approved") {
            return { backgroundColor: "#E4F3E7", color: "#27bd3b" };
        }
        return undefined;
    };

    /** Routes the Yoti primary button click based on current status and retry method. */
    handleYotiPrimaryButtonClick = () => {
        const status = this.state.yotiSessionStatus;
        if (status === "Trigger Yoti Verification") {
            this.handleVerifyPhotoId();
            return;
        }
        if (status === "Approved") return;
        if (this.state.retryViaApp) {
            this.requestRetryViaApp();
            return;
        }
        this.setState({ confirmActionPopupVisible: true });
    };

    /** Creates a new Yoti verification session for the contact. */
    handleVerifyPhotoId = () => {
        const contactId = this.getYotiContactId();

        if (!contactId) {
            this.setState({ yotiSessionStatus: "Retry" });
            notify({ message: "Contact must be saved before initiating Yoti verification.", width: 360, shading: true, position: "center" }, "error", 2200);
            return;
        }

        const requestPayload = { contactId, retryViaApp: this.state.retryViaApp };
        this.setState({ loadPanelVisible: true });
        this.artistService
            .createYotiSession(requestPayload)
            .then((res) => this.handleVerifyPhotoIdSuccess(res))
            .catch((error: any) => {
                this.setState({ yotiSessionStatus: "Retry" });
                notify(
                    {
                        message: this.getIdCheckApiErrorMessage(error, "Failed to create Yoti session."),
                        width: 420,
                        shading: true,
                        position: "center",
                    },
                    "error",
                    2200,
                );
            })
            .finally(() => {
                this.setState({ loadPanelVisible: false });
            });
    };

    /**
     * Handles the Yoti identity verification session API response.
     * Updates yotiSessionStatus based on whether the session was created successfully.
     */
    handleVerifyPhotoIdSuccess = (response: AxiosResponse<any>) => {
        const responseData = response.data?.data;
        const sessionId = responseData?.sessionId || responseData?.SessionId || "";
        const resolvedContactId =
            responseData?.contactId ||
            responseData?.contactID ||
            responseData?.userTrackingId ||
            this.getYotiContactId() ||
            "";
        if (response.status === 200) {
            this.setState({
                loadPanelVisible: false,
                yotiSessionStatus: "Requested",
                yotiPopupVisible: true,
                yotiUserViewUrl: response.data?.data?.userViewUrl ?? "",
                yotiVerificationId: sessionId,
                yotiResolvedContactId: resolvedContactId || this.state.yotiResolvedContactId,
                requestFormData: {
                    ...this.state.requestFormData,
                    idVerificationCheckResultId: "5",
                },
            });
        } else {
            this.setState({
                loadPanelVisible: false,
                yotiSessionStatus: "Retry",
            });
        }
    };

    /** Handles the retry-via-app radio group selection change. */
    handleChangeRetryViaApp = (dxValue: RadioButtonOnSelectionChanged) => {
        this.setState({ retryViaApp: dxValue.value === "Retry Via App" });
    };

    handleOpenYotiSessionReview = () => {
        const contactId = this.getYotiContactId();

        if (contactId) {
            this.loadLatestIdCheckByContactId(contactId, false).then((canOpenPopup) => {
                if (canOpenPopup) {
                    this.setState({ notepadPopupVisible: true });
                }
            });
            return;
        }
    };

    /** Handles the "View Yoti Session" action from the Confirm Action popup. */
    handleConfirmActionViewSession = () => {
        this.setState({ confirmActionPopupVisible: false });
        this.handleOpenYotiSessionReview();
    };

    /** Handles the "New ID Required" action from the Confirm Action popup. */
    handleConfirmActionNewIdRequired = () => {
        this.setState({ confirmActionPopupVisible: false });
        this.handleVerifyPhotoId();
    };

        /**
     * Handles the "SET TO REJECTED" action from the Confirm Action popup.
     * Calls UpdateContactIdCheck with iDVerificationCheckResultId = "99" (Rejected).
     * On success: Yoti button text becomes "Rejected" and retryViaApp is reset to false,
     * so the next click on the Yoti button opens the Confirm Action popup again.
     * On failure: the Yoti status is left unchanged and an error toast is shown.
     */
    handleConfirmActionSetToRejected = () => {
        const contactId = this.getYotiContactId();
        if (!contactId) {
            this.showShadedNotify("Contact ID not found", 'error', 2200);
            return;
        }

        const updatePayload: IdCheckUpdateRequest = {
            contactId,
            iDVerificationCheckResultId: "99",
        };

        this.setState({ confirmActionPopupVisible: false });

        this.artistService.updateIdCheckVerification(updatePayload)
            .then(() => {
                this.setState({ yotiSessionStatus: "Rejected", retryViaApp: false });
                this.showShadedNotify("Yoti status successfully set to Rejected", 'success', 2200);
            })
            .catch((error) => {
                this.showShadedNotify(
                    this.getIdCheckApiErrorMessage(error, "Failed to set Yoti status to Rejected"),
                    'error',
                    2200
                );
            });
    };

    /**
     * Sends a "Retry Via App" (checkResultId = 6) request to the UpdateContactIdCheck API.
     */
    requestRetryViaApp = () => {
        const contactId = this.getYotiContactId();
        if (!contactId) {
            this.showShadedNotify("Contact ID not found", 'error', 2200);
            return;
        }

        const updatePayload: IdCheckUpdateRequest = {
            contactId,
            iDVerificationCheckResultId: "6",
        };

        this.setState({ confirmActionPopupVisible: false });

        this.artistService.updateIdCheckVerification(updatePayload)
            .then(() => {
                this.setState({ yotiSessionStatus: "Retry Via App Requested" });
                this.showShadedNotify("Yoti Retry Via App Successfully Requested", 'success', 2200);
            })
            .catch(() => {
                this.setState({ yotiSessionStatus: "Retry Via App Request Failed" });
                this.showShadedNotify("Yoti Retry Request Failed", 'error', 2200);
            });
    };

    loadLatestIdCheckByContactId = (contactId: string, shouldPersist: boolean, showErrorNotifications: boolean = true): Promise<boolean> => {
        return this.artistService
            .getLatestIdCheckByContactId(contactId)
            .then((response) => {
                if (response.status !== 200) {
                    if (showErrorNotifications) {
                        this.showShadedNotify(this.getIdCheckApiErrorMessage(response, "Unable to open session review."), "error", 2200);
                    }
                    return false;
                }

                const wrapperPayload = (response.data?.data || {}) as IdCheckLatestByContactApiResponse;
                const payloadList = (wrapperPayload?.summaries || []) as IdCheckLatestByContactResponse[];
                const contactDetails = wrapperPayload?.contactDetails;
                const sortedSessions = [...payloadList].sort((a, b) => {
                    return new Date(b?.lastUpdatedOn || 0).getTime() - new Date(a?.lastUpdatedOn || 0).getTime();
                });

                if (!sortedSessions.length) {
                    if (showErrorNotifications) {
                        this.showShadedNotify(this.getIdCheckApiErrorMessage(response, "No ID verification sessions available for this contact."), "error", 2200);
                    }
                    return false;
                }

                const mappedSessions = sortedSessions.map((payload) => this.mapLatestIdCheckToSession(payload));
                const selectedSession = mappedSessions.find((session) => session.draftActiveLabel === "Yes") || mappedSessions[0];
                const selectedDecisionFromContact = this.mapCheckResultIdToDecision((contactDetails?.checkResultId || "").toString());
                const yotiStatusFromContact = this.mapCheckResultIdToYotiStatus((contactDetails?.checkResultId || "").toString());
                const resolvedContactId = (contactDetails?.contactId || contactId || "").toString();

                const nextState: Partial<AddContactState> = {
                    idVerificationSessions: mappedSessions,
                    selectedIdVerificationSessionId: selectedSession.draftVerificationSessionId,
                    selectedVerificationDecision: selectedDecisionFromContact || selectedSession.draftReviewerDecision,
                    selectedVerificationReviewerNotes: selectedSession.draftReviewerNotes,
                    selectedVerificationIsActive: ["yes", "active", "true", "1"].includes(
                        (selectedSession.draftActiveLabel || "").trim().toLowerCase(),
                    ),
                    yotiVerificationId: selectedSession.draftSessionId || this.state.yotiVerificationId,
                    yotiResolvedContactId: resolvedContactId || this.state.yotiResolvedContactId,
                };

                if (shouldPersist) {
                    nextState.yotiSessionStatus = yotiStatusFromContact || this.state.yotiSessionStatus;
                    nextState.retryViaApp = (contactDetails?.checkResultId || "").toString() === "6";
                }

                this.setState(nextState as AddContactState);

                return true;
            })
            .catch((error: any) => {
                if (showErrorNotifications) {
                    this.showShadedNotify(this.getIdCheckApiErrorMessage(error, "Unable to open session review."), "error", 2200);
                }
                return false;
            });
    };

    mapLatestIdCheckToSession = (payload: IdCheckLatestByContactResponse): any => {
        const checks = payload?.checks || [];
        const overallOutcome = this.formatSessionReviewDisplayText(payload?.overallOutcome || this.deriveOverallOutcome(checks), "Requires review");
        const reviewerDecision = this.deriveReviewerDecision(overallOutcome);
        const sessionStateLabel = this.formatSessionReviewDisplayText(payload?.state || "", "Ongoing");

        const sections = checks.map((check) => {
            const checkTypeIdStr = (check?.checkTypeId || "").toString();
            const sectionMeta = this.mapCheckTypeIdToSectionMeta(checkTypeIdStr);
            const recommendationId = (check?.recommendationId || "").toString();
            const recommendationLabel = this.mapRecommendationIdToLabel(recommendationId);
            const subChecks = check?.subChecks || [];

            const mappedChecks = subChecks.map((subCheck: any) => {
                const subCheckName = (subCheck?.subCheck || "").toLowerCase();
                const isAiFaceMatch = subCheckName === "ai_face_match";
                const confidenceDetail = subCheck?.details?.find((detail: any) => (detail.name || "").toLowerCase() === "confidence_score");
                const confidenceScore = confidenceDetail?.value ? parseFloat(confidenceDetail.value) : NaN;

                return {
                    draftCheckFieldName: isAiFaceMatch ? "draftAiFaceMatchConfidence" : `draft${this.formatIdCheckLabel(subCheck?.subCheck || "").replace(/\s+/g, "")}`,
                    draftCheckLabel: isAiFaceMatch ? "AI face match" : this.formatIdCheckLabel(subCheck?.subCheck || ""),
                    draftCheckPassed: (subCheck?.result || "").toUpperCase() === "PASS",
                    draftCheckResultLabel: this.formatIdCheckLabel(subCheck?.result || "Unknown"),
                    draftConfidenceScore: Number.isFinite(confidenceScore) ? confidenceScore : undefined,
                };
            });

            return {
                draftSectionFieldName: sectionMeta.fieldName,
                draftSectionLabel: sectionMeta.label,
                draftSectionApproved: recommendationLabel === "Approve",
                draftSectionRecommendation: recommendationLabel,
                draftChecks: mappedChecks,
            };
        });

        const sessionId = payload?.summaryId
            ? (typeof payload.summaryId === 'number' ? payload.summaryId : parseInt(payload.summaryId.toString()))
            : Date.now();

        return {
            draftVerificationSessionId: sessionId,
            draftSessionId: payload?.sessionId || this.state.yotiVerificationId || "-",
            draftUserTrackingId: payload?.userTrackingId || this.getYotiContactId() || "-",
            draftActiveLabel: payload?.active ? "Yes" : "No",
            draftOverallStatusLabel: overallOutcome,
            draftStatusLabel: sessionStateLabel,
            draftBioConsentValue: payload?.biometricConsentTimestamp || "",
            draftLastUpdatedBy: "Last Updated By",
            draftLastUpdatedOn: payload?.lastUpdatedOn || "",
            draftVerificationSections: sections,
            draftReviewerDecision: reviewerDecision,
            draftReviewerNotes: payload?.comments || "",
            draftReviewedBy: "Reviewer",
            draftReviewedOn: payload?.lastUpdatedOn || "",
        };
    };

    /** Converts snake_case check/sub-check values to readable labels. */
    formatIdCheckLabel = (value: string) => {
        const normalized = (value || "").toLowerCase().replace(/_/g, " ").trim();
        if (!normalized) {
            return "-";
        }
        return normalized
            .split(" ")
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ");
    };

    mapCheckTypeToSectionMeta = (type: string) => {
        const normalizedType = (type || "").toUpperCase();
        if (normalizedType === "DOCUMENT") return { fieldName: "draftDocumentAuthenticity", label: "Document authenticity", typeId: 10 };
        if (normalizedType === "FACE") return { fieldName: "draftFaceMatch", label: "Face match", typeId: 11 };
        if (normalizedType === "LIVENESS") return { fieldName: "draftLiveness", label: "Liveness", typeId: 12 };
        return { fieldName: `draft${this.formatIdCheckLabel(normalizedType).replace(/\s+/g, "")}`, label: this.formatIdCheckLabel(normalizedType), typeId: 10 };
    };

    mapCheckTypeIdToSectionMeta = (typeId: string) => {
        const id = (typeId || "").toString();
        if (id === "10") return { fieldName: "draftDocumentAuthenticity", label: "Document authenticity", typeId: 10 };
        if (id === "11") return { fieldName: "draftFaceMatch", label: "Face match", typeId: 11 };
        if (id === "12") return { fieldName: "draftLiveness", label: "Liveness", typeId: 12 };
        return { fieldName: "draftUnknownCheck", label: "Unknown check", typeId: 10 };
    };

    extractConfidenceScore = (check: IdCheckCheckApi) => {
        const breakdown = check?.subChecks || [];
        const faceMatchSubCheck = breakdown.find((subCheck) => {
            const subCheckName = (subCheck.subCheck || "").toLowerCase();
            return subCheckName === "face_match" || subCheckName === "ai_face_match";
        });
        const confidenceValue = faceMatchSubCheck?.details?.find((detail) => (detail.name || "").toLowerCase() === "confidence_score")?.value;
        const score = confidenceValue ? parseFloat(confidenceValue) : NaN;
        return Number.isFinite(score) ? score : null;
    };

    deriveOverallOutcome = (checks: IdCheckCheckApi[]) => {
        if (!checks || checks.length === 0) return "Requires Review";
        const hasAnyNonApproveRecommendation = checks.some((check) => (check?.recommendation || "").toUpperCase() !== "APPROVE");
        const hasReasonOrRecovery = checks.some((check) => {
            return Boolean((check?.reason || "").trim()) || Boolean((check?.recoverySuggestion || "").trim());
        });
        const hasPhysicalDocumentCapturedFail = checks.some((check) => {
            return (check?.subChecks || []).some((subCheck) => {
                const subCheckName = (subCheck?.subCheck || "").toLowerCase();
                const resultValue = (subCheck?.result || "").toUpperCase();
                return subCheckName === "physical_document_captured" && resultValue === "FAIL";
            });
        });
        const hasLowFaceMatchScore = checks.some((check) => {
            const confidenceScore = this.extractConfidenceScore(check);
            return confidenceScore !== null && confidenceScore < 0.85;
        });
        const allApproveRecommendations = checks.every((check) => (check?.recommendation || "").toUpperCase() === "APPROVE");
        if (allApproveRecommendations && !hasAnyNonApproveRecommendation && !hasReasonOrRecovery && !hasPhysicalDocumentCapturedFail && !hasLowFaceMatchScore) {
            return "Approved";
        }
        return "Requires Review";
    };

    deriveReviewerDecision = (outcomeValue: string) => {
        const normalizedOutcome = (outcomeValue || "").toLowerCase();
        if (normalizedOutcome.includes("approved")) return "Approve";
        if (normalizedOutcome.includes("reject")) return "Reject";
        return "Requires Review";
    };

    mapRecommendationToLabel = (recommendationValue: string) => {
        const recommendation = (recommendationValue || "").toUpperCase();
        if (recommendation === "APPROVE") return "Approve";
        if (recommendation === "REJECT") return "Reject";
        return "Consider";
    };

    mapRecommendationIdToLabel = (recommendationId: string) => {
        const id = (recommendationId || "").toString();
        if (id === "20") return "Approve";
        if (id === "99") return "Reject";
        return "Consider";
    };

    mapOutcomeToContactIdCheckResultId = (outcomeValue: string) => {
        const normalizedOutcome = (outcomeValue || "").toLowerCase();
        if (normalizedOutcome.includes("approved")) return "20";
        if (normalizedOutcome.includes("reject")) return "99";
        if (normalizedOutcome.includes("requested")) return "5";
        return "10";
    };

    mapCheckResultIdToDecision = (checkResultId: string) => {
        const normalizedValue = (checkResultId || "").toString();
        if (normalizedValue === "20") return "Approve";
        if (normalizedValue === "99") return "Reject";
        return "Requires Review";
    };

    /**
     * Handles the APPLY button click in the verification review popup.
     * Validates reviewer notes, maps decision to checkResultId, and calls Update API.
     */
    handleVerificationApply = () => {
        const { selectedVerificationReviewerNotes, selectedVerificationDecision, selectedVerificationIsActive, selectedIdVerificationSessionId, idVerificationSessions } = this.state;

        if (!selectedVerificationReviewerNotes || selectedVerificationReviewerNotes.trim() === "") {
            notify({ message: "Reviewer notes are required", width: 300, shading: true, position: "center" }, 'error', 2200);
            return;
        }

        const selectedSession = idVerificationSessions.find((session) => session.draftVerificationSessionId === selectedIdVerificationSessionId);
        if (!selectedSession) {
            notify({ message: "Selected session not found", width: 300, shading: true, position: "center" }, 'error', 2200);
            return;
        }

        const decisionMap: { [key: string]: string } = {
            "Approve": "20",
            "Reject": "99",
            "Requires Review": "10",
        };
        const checkResultId = decisionMap[selectedVerificationDecision] || "10";

        const contactId = this.getYotiContactId();
        if (!contactId) {
            notify({ message: "Contact ID not found", width: 300, shading: true, position: "center" }, 'error', 2200);
            return;
        }

        const updatePayload: IdCheckUpdateRequest = {
            contactId,
            iDVerificationCheckResultId: checkResultId,
        };

        this.artistService.updateIdCheckVerification(updatePayload)
            .then((response) => {
                notify({ message: "Verification review submitted successfully", width: 300, shading: true, position: "center" }, 'success', 2200);
                setTimeout(() => {
                    this.setState({ notepadPopupVisible: false });
                }, 1500);
            })
            .catch((error) => {
                const errorMessage = this.getIdCheckApiErrorMessage(error, "Failed to submit verification review");
                notify({ message: errorMessage, width: 300, shading: true, position: "center" }, 'error', 2200);
            });
    };

    /**
     * Synchronizes the verification detail panel with the selected ID verification session row.
     */
    handleIdVerificationSessionSelectionChanged = (event: any) => {
        const selectedSession = event.selectedRowsData?.[0];
        if (!selectedSession) {
            return;
        }
        this.setState({
            selectedIdVerificationSessionId: selectedSession.draftVerificationSessionId,
            selectedVerificationDecision: selectedSession.draftReviewerDecision,
            selectedVerificationReviewerNotes: selectedSession.draftReviewerNotes,
            selectedVerificationIsActive: ["yes", "active", "true", "1"].includes(
                (selectedSession.draftActiveLabel || "").trim().toLowerCase(),
            ),
        });
    };

    /**
     * Exports all ID verification session grid rows to an Excel workbook.
     */
    onIdVerificationSessionsExporting = (e: onExportingEvent) => {
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet("Id Verification Sessions");
        exportDataGrid({
            component: e.component,
            worksheet: worksheet,
            autoFilterEnabled: true,
        }).then(() => {
            workbook.xlsx.writeBuffer().then((buffer) => {
                saveAs(new Blob([buffer], { type: "application/octet-stream" }), "IdVerificationSessions.xlsx");
            });
        });
        e.cancel = true;
    };

    /**
     * Formats session status text into a clean sentence-style label for display.
     */
    formatSessionReviewDisplayText = (value: string, fallbackValue: string) => {
        const textToFormat = (value || fallbackValue || "").trim();
        if (!textToFormat) {
            return fallbackValue;
        }
        const lowerCaseText = textToFormat.toLowerCase().replace(/_/g, " ");
        return lowerCaseText.charAt(0).toUpperCase() + lowerCaseText.slice(1);
    };

    /**
     * Returns the compact status tag text shown in the Session review header.
     */
    getSessionReviewHeaderStatus = (session: any) => {
        return this.formatSessionReviewDisplayText(session?.draftOverallStatusLabel, "Requires review");
    };

    /**
     * Returns the status text shown for the Session state card.
     */
    getSessionReviewState = (session: any) => {
        return this.formatSessionReviewDisplayText(session?.draftStatusLabel || session?.draftOverallStatusLabel, "Unknown");
    };

    /**
     * Returns the class suffix to colour Session state based on value.
     */
    getSessionReviewStateClass = (status: string) => {
        const normalizedStatus = (status || "").toLowerCase();
        if (normalizedStatus.includes("complete")) return "artist-profile__verification-session-review-value--completed";
        if (normalizedStatus.includes("expire")) return "artist-profile__verification-session-review-value--expired";
        if (normalizedStatus.includes("ongoing") || normalizedStatus.includes("pending") || normalizedStatus.includes("review")) return "artist-profile__verification-session-review-value--ongoing";
        return "artist-profile__verification-session-review-value--default";
    };

    /**
     * Formats biometric consent value as a readable date/time when possible.
     */
    formatSessionReviewDateTime = (dateTimeValue: string) => {
        if (!dateTimeValue) {
            return "-";
        }
        const parsedDate = moment(dateTimeValue);
        if (!parsedDate.isValid()) {
            return dateTimeValue;
        }
        return parsedDate.format("DD MMM YYYY, HH:mm");
    };

    /**
     * Extracts the most useful message from an API response/error payload.
     */
    getIdCheckApiErrorMessage = (payload: any, fallbackMessage: string) => {
        const source = payload?.response?.data || payload?.data || payload;
        if (typeof source === "string" && source.trim()) return source;
        const message = source?.message || source?.errorMessage || source?.title || source?.detail;
        if (typeof message === "string" && message.trim()) return message;
        const errorCollection = source?.error || source?.errors;
        if (Array.isArray(errorCollection) && errorCollection.length) {
            const firstError = errorCollection[0];
            if (typeof firstError === "string" && firstError.trim()) return firstError;
            const firstErrorMessage = firstError?.errorMessage || firstError?.message || firstError?.detail;
            if (typeof firstErrorMessage === "string" && firstErrorMessage.trim()) return firstErrorMessage;
        }
        return fallbackMessage;
    };

    /**
     * Shows a DevExtreme notify toast with shading without triggering the parent
     * Popup's hideOnOutsideClick handler.
     */
    showShadedNotify = (message: string, type: string, duration: number) => {
        const toastSelector = '.dx-toast-wrapper, .dx-toast, .dx-overlay-shader';
        const stop = (e: Event) => {
            const target = e.target as Element | null;
            if (!target) {
                return;
            }
            const isWithinToast =
                (typeof target.matches === 'function' && target.matches(toastSelector)) ||
                (typeof target.closest === 'function' && !!target.closest(toastSelector));
            if (isWithinToast) {
                e.stopImmediatePropagation();
            }
        };
        const interceptedEvents = ['pointerdown', 'mousedown', 'touchstart'];
        interceptedEvents.forEach((eventName) => document.addEventListener(eventName, stop, true));
        setTimeout(() => {
            interceptedEvents.forEach((eventName) => document.removeEventListener(eventName, stop, true));
        }, duration + 500);
        notify({ message, width: 420, shading: true, position: 'center' }, type, duration);
    };

    getVerificationPillCssModifier = (status: string) => {
        const normalizedStatus = (status || "").toLowerCase().trim();
        if (normalizedStatus === "approved") return "artist-profile__verification-pill--approved";
        if (normalizedStatus === "rejected") return "artist-profile__verification-pill--rejected";
        if (normalizedStatus === "requires review") return "artist-profile__verification-pill--requires-review";
        if (normalizedStatus === "requested") return "artist-profile__verification-pill--requested";
        return "";
    };

    getSessionReviewPillCssModifier = (status: string) => {
        const normalizedStatus = (status || "").toLowerCase().trim();
        if (normalizedStatus === "approved") return "artist-profile__verification-session-review-pill--approved";
        if (normalizedStatus === "rejected") return "artist-profile__verification-session-review-pill--rejected";
        if (normalizedStatus === "requires review") return "artist-profile__verification-session-review-pill--requires-review";
        if (normalizedStatus === "requested") return "artist-profile__verification-session-review-pill--requested";
        return "";
    };

    render() {
        return (
            <div className="page-content">
                <LoadPanel shadingColor="rgba(0,0,0,0.4)" visible={this.state.loadPanelVisible} />
                <div className="container">
                    <div className="row mt-3 mb-5" hidden={this.state.isEditMode}>
                        <div className="col-12 col-md-2">
                            <button className="btn btn-primary btn--large" onClick={this.onEditButtonClick}>
                                EDIT
                            </button>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col-lg-9">
                            <h5 className="artist-profile__section-header">
                                <b>Contact Details</b>
                                <span className="mx-3">({this.state.requestFormData.id})</span>
                            </h5>
                            <div>
                                Name
                                <span className="unscheduled-shift">*</span>
                            </div>
                            <div>
                                <TextBox
                                    width={"100%"}
                                    readOnly={false}
                                    onValueChanged={this.handleChangeContactName}
                                    valueChangeEvent="keyup"
                                    value={this.state.requestFormData.name}
                                    disabled={!this.state.isEditMode}
                                />
                            </div>                                                    
                            <div className="mt-3">
                                Organisation
                                <span className="unscheduled-shift">*</span>
                            </div>
                            <div>
                                <SelectBox
                                    className="mt-2"
                                    dataSource={this.state.organisationLookUp}
                                    width={"100%"}
                                    readOnly={false}
                                    valueExpr="id"
                                    displayExpr="value"
                                    onValueChanged={this.handleChangeOrganisationValue}
                                    value={this.state.requestFormData.organisationTypeId}
                                    disabled={!this.state.isEditMode}
                                />
                            </div>
                            <div className="mt-3" hidden={this.state.requestFormData.organisationTypeId == "10" ||  this.state.requestFormData.organisationTypeId == "30"}>
                                Provider
                                <span className="unscheduled-shift">*</span>
                            </div>
                            <div hidden={this.state.requestFormData.organisationTypeId == "10" ||  this.state.requestFormData.organisationTypeId == "30"}>
                                <LookupTypeListDynamic
                                    lookupTypeIndex={LookupTypeIndexes.providerType}
                                    onValueChanged={this.handleChangeProviderTypeSelect}
                                    isRoot={false}
                                    parentMappingId={""}
                                    displayExpression={"value"}
                                    value={this.state.requestFormData.businessEntityId}
                                    isDisabled={!this.state.isEditMode}
                                />
                            </div>
                            <div className="mt-3" hidden={this.state.requestFormData.organisationTypeId == "20" ||  this.state.requestFormData.organisationTypeId == "30"}>
                                Client
                                <span className="unscheduled-shift">*</span>
                            </div>
                            <div hidden={this.state.requestFormData.organisationTypeId == "20" ||  this.state.requestFormData.organisationTypeId == "30"}>
                                <LookupTypeListDynamic
                                    lookupTypeIndex={LookupTypeIndexes.clientType}
                                    onValueChanged={this.handleChangeClientTypeSelect}
                                    isRoot={false}
                                    parentMappingId={""}
                                    displayExpression={"value"}
                                    value={this.state.requestFormData.businessEntityId}
                                    isDisabled={!this.state.isEditMode}
                                />
                            </div>
                            {/* <div className="mt-3" hidden={this.state.requestFormData.organisationTypeId == "20" ||  this.state.requestFormData.organisationTypeId == "10"}>
                                Company
                                <span className="unscheduled-shift">*</span>
                            </div>
                            <div hidden={this.state.requestFormData.organisationTypeId == "20" ||  this.state.requestFormData.organisationTypeId == "10"}>
                                <LookupTypeListDynamic
                                    lookupTypeIndex={LookupTypeIndexes.contactCompanyType}
                                    onValueChanged={this.handleChangeCompanyTypeSelect}
                                    isRoot={false}
                                    parentMappingId={""}
                                    displayExpression={"value"}
                                    value={this.state.requestFormData.businessEntityId}
                                    isDisabled={!this.state.isEditMode}
                                />
                            </div> */}
                            <div className="mt-3" hidden={this.state.requestFormData.organisationTypeId == "20" ||  this.state.requestFormData.organisationTypeId == "10"}>
                                Company
                                <span className="unscheduled-shift">*</span>
                            </div>
                            <div hidden={this.state.requestFormData.organisationTypeId == "20" ||  this.state.requestFormData.organisationTypeId == "10"}>
                                <SelectBox
                                    className="mt-2"
                                    dataSource={this.state.companyLookUp}
                                    width={"100%"}
                                    readOnly={false}
                                    valueExpr="id"
                                    displayExpr="value"
                                    onValueChanged={this.handleChangeCompanyTypeSelect}
                                    value={this.state.requestFormData.businessEntityId}
                                    disabled={!this.state.isEditMode}
                                />
                            </div>
                            <div className="mt-3">
                                Contact Type
                                <span className="unscheduled-shift">*</span>
                            </div>
                            <div>
                                <LookupTypeListDynamic
                                    lookupTypeIndex={LookupTypeIndexes.contactTypeDetails}
                                    onValueChanged={this.handleContactTypeValue}
                                    isRoot={false}
                                    parentMappingId={this.state.requestFormData.organisationTypeId}
                                    displayExpression={"value"}
                                    value={this.state.requestFormData.contactTypeId}
                                    isDisabled={!this.state.isEditMode}
                                />
                            </div>
                            <div className="mt-3">
                                Email
                                <span className="unscheduled-shift" hidden={this.state.requestFormData.user.active == undefined || this.state.requestFormData.user.active == "No" || this.state.requestFormData.user.active == "False" 
                                    || this.state.requestFormData.user.active == ""}>*</span>
                            </div>
                            <div className="row mx-0">
                                <div className="col-12 col-lg-12 row pr-0">
                                    <div className="col-12 col-xl-8 pl-0">
                                        <TextBox
                                            width={"100%"}
                                            readOnly={false}
                                            onValueChanged={this.handleChangeEmail}
                                            valueChangeEvent="keyup"
                                            value={this.state.requestFormData.email}
                                            disabled={!this.state.isEditMode}
                                        />
                                    </div>
                                    <div className="col-12 col-xl-4 pl-0 mt-3 mt-xl-0" hidden={!this.state.isEditMode}>
                                        <button
                                            className="btn btn-primary btn--large p-1"
                                            disabled={this.state.requestFormData.email == ""}
                                            onClick={(e: MouseEvent) => {
                                                e.preventDefault();
                                                this.changeEmail();
                                            }}
                                        >
                                            Change Email
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="mt-3">
                                Email Remittance
                            </div>
                            <div>
                                <RadioGroup
                                    items={this.taxApplicable && this.taxApplicable.length > 0 ? this.taxApplicable : []}
                                    displayExpr="value"
                                    valueExpr="value"
                                    value={this.state.requestFormData.emailRemittance == "Yes" || this.state.requestFormData.emailRemittance == "True"
                                            ? "Yes"
                                            : "No"
                                    }
                                    onValueChanged={this.handleChangeEmailRemittance}
                                    layout="horizontal"
                                    disabled={!this.state.isEditMode}
                                />
                            </div>
                            <div className="mt-3">
                                Mobile
                            </div>
                            <div>
                                <TextBox
                                    width={"100%"}
                                    readOnly={false}
                                    onValueChanged={this.handleChangeMobile}
                                    valueChangeEvent="keyup"
                                    value={this.state.requestFormData.mobile}
                                    disabled={!this.state.isEditMode}
                                />
                            </div>
                            <div className="mt-3">
                                Job Title
                            </div>
                            <div>
                                <TextBox
                                    width={"100%"}
                                    readOnly={false}
                                    onValueChanged={this.handleChangeJobTitle}
                                    valueChangeEvent="keyup"
                                    value={this.state.requestFormData.jobTitle}
                                    disabled={!this.state.isEditMode}
                                />
                            </div>
                            <div className="mt-3">
                                Active
                                <span className="unscheduled-shift">*</span>
                            </div>
                            <div>
                                <RadioGroup
                                    items={this.taxApplicable && this.taxApplicable.length > 0 ? this.taxApplicable : []}
                                    displayExpr="value"
                                    valueExpr="value"
                                    value={this.state.requestFormData.active == "Yes" || this.state.requestFormData.active == "True"
                                            ? "Yes"
                                            : "No"
                                    }
                                    onValueChanged={this.handleChangeContactActive}
                                    layout="horizontal"
                                    disabled={!this.state.isEditMode}
                                />
                            </div>
                            <div className="artist-profile__section-header mt-3">
                                <span className="font-size-one">
                                    Last Updated:&nbsp;{this.state.contactCreatedDateTime}&nbsp;|&nbsp;Date Created:&nbsp;{this.contactLastUpdatedDisplay(this.state.requestFormData.dateCreated, true)}
                                </span>
                            </div>
                        </div>
                        <div className="col-lg-9">
                            <div className="artist-profile__edit-section"></div>
                            <h5 className="artist-profile__section-header mb-0">
                                <b>Identifications</b>
                            </h5>
                            <div className="small text-muted mb-3">Only required for individuals</div>
                            <div className="artist-profile__verification-subtitle mt-3">Yoti verification</div>
                            <button
                                className="btn btn--ghost btn--ghost--teal btn--large w-50 mt-2 d-flex align-items-center justify-content-center"
                                style={{ ...(this.getYotiStatusStyles(this.state.yotiSessionStatus) || {}), gap: "8px" }}
                                onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                                    e.preventDefault();
                                    this.handleYotiPrimaryButtonClick();
                                }}
                                disabled={this.state.yotiSessionStatus === "Approved"}
                                aria-label={this.state.yotiSessionStatus}
                                title={this.state.yotiSessionStatus}
                                type="button"
                            >
                                <span className="d-flex align-items-center" style={{ gap: "8px" }}>
                                    {this.state.yotiSessionStatus === "Approved" && (
                                        <FontAwesomeIcon icon={faCheck} aria-hidden="true" />
                                    )}
                                    {this.state.yotiSessionStatus === "Rejected" && (
                                        <FontAwesomeIcon icon={faXmark} aria-hidden="true" />
                                    )}
                                    <span>{this.state.yotiSessionStatus}</span>
                                </span>
                                <FontAwesomeIcon icon={faClipboardList} aria-hidden="true" />
                            </button>
                            <div className="mt-2">
                                <RadioGroup
                                    items={["Retry Via App", "Via Admin Team"]}
                                    value={this.state.retryViaApp ? "Retry Via App" : "Via Admin Team"}
                                    onValueChanged={this.handleChangeRetryViaApp}
                                    layout="horizontal"
                                />
                            </div>
                            <button
                                className="btn btn--ghost btn--ghost--teal btn--large w-50 mt-2 d-flex align-items-center justify-content-center"
                                style={{ gap: "8px" }}
                                onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                                    e.preventDefault();
                                    this.handleOpenYotiSessionReview();
                                }}
                                aria-label="View Yoti session"
                                type="button"
                            >
                                <FontAwesomeIcon icon={faArrowUpRightFromSquare} aria-hidden="true" />
                                <span>View Yoti session</span>
                            </button>
                        </div>
                        <div className="col-lg-9">
                            <div className="artist-profile__edit-section"></div>
                            <h5 className="artist-profile__section-header">
                                <b>User Details</b>
                                <span className="mx-3">({this.state.requestFormData.user.id})</span>
                            </h5>
                            <div>
                                User Name
                                <span className="unscheduled-shift" hidden={this.state.requestFormData.user.active == undefined || this.state.requestFormData.user.active == "No" || this.state.requestFormData.user.active == "False" 
                                    || this.state.requestFormData.user.active == ""}>*</span>
                            </div>
                            <div>
                                <TextBox
                                    width={"100%"}
                                    readOnly={false}
                                    onValueChanged={this.handleChangeUserName}
                                    valueChangeEvent="keyup"
                                    value={this.state.requestFormData.user.name}
                                    disabled={!this.state.isEditMode}
                                />
                            </div>
                            <div className="mt-3">
                                User Role
                                <span className="unscheduled-shift" hidden={this.state.requestFormData.user.active == undefined || this.state.requestFormData.user.active == "No" || this.state.requestFormData.user.active == "False" 
                                    || this.state.requestFormData.user.active == ""}>*</span>
                            </div>
                            <div>
                                <SelectBox
                                    className="mt-2"
                                    dataSource={this.state.roleLookUp}
                                    width={"100%"}
                                    readOnly={false}
                                    valueExpr="id"
                                    displayExpr="value"
                                    onValueChanged={this.handleChangeUserRoleValue}
                                    value={this.state.requestFormData.user.userRole.id}
                                    disabled={!this.state.isEditMode}
                                />
                            </div>                                    
                            <div className="row">
                                <div className='col'>
                                    <div className="mt-3">
                                        Active User
                                        <span className="unscheduled-shift">*</span>
                                    </div>
                                    <div>
                                        <RadioGroup
                                            items={this.taxApplicable && this.taxApplicable.length > 0 ? this.taxApplicable : []}
                                            displayExpr="value"
                                            valueExpr="value"
                                            value={this.state.requestFormData?.user?.active == "Yes" || this.state.requestFormData?.user?.active == "True"
                                                ? "Yes"
                                                : "No"
                                            }
                                            onValueChanged={this.handleChangeUserActive}
                                            layout="horizontal"
                                            disabled={!this.state.isEditMode}
                                        />
                                    </div>
                                </div>
                                {/* {true && <> */}
                                <div className="col">
                                    <div className="mt-3">
                                        Allow Internal Web Access?
                                        {/* <span className="unscheduled-shift">*</span> */}
                                    </div>

                                    <div>
                                        <div>
                                        <RadioGroup
                                            items={this.taxApplicable && this.taxApplicable.length > 0 ? this.taxApplicable : []}
                                            displayExpr="value"
                                            valueExpr="value"
                                            value={this.state.requestFormData?.user?.allowWebApp == "Yes" || this.state.requestFormData?.user?.allowWebApp == "True"
                                                ? "Yes"
                                                : "No"
                                            }
                                            onValueChanged={this.handleChangeAllowWebApp}
                                            layout="horizontal"
                                            disabled={!this.state.isEditMode}
                                        />
                                    </div>
                                    </div>
                                </div>

                                <div className="col">
                                    <div className="mt-3">
                                        Disallow App Access?
                                        {/* <span className="unscheduled-shift">*</span> */}
                                    </div>

                                    <div>
                                        <RadioGroup
                                            items={this.taxApplicable && this.taxApplicable.length > 0 ? this.taxApplicable : []}
                                            displayExpr="value"
                                            valueExpr="value"
                                            value={this.state.requestFormData?.user?.disallowApp == "Yes" || this.state.requestFormData?.user?.disallowApp == "True"
                                                ? "Yes"
                                                : "No"
                                            }
                                            onValueChanged={this.handleChangeDisallowApp}
                                            layout="horizontal"
                                            disabled={!this.state.isEditMode}
                                        />
                                    </div>
                                </div>

                                <div className="col">
                                    <div className="mt-3">
                                        Disallow Portal Access?
                                        {/* <span className="unscheduled-shift">*</span> */}
                                    </div>

                                    <div>
                                        <RadioGroup
                                            items={this.taxApplicable && this.taxApplicable.length > 0 ? this.taxApplicable : []}
                                            displayExpr="value"
                                            valueExpr="value"
                                            value={this.state.requestFormData?.user?.disallowPortal == "Yes" || this.state.requestFormData?.user?.disallowPortal == "True"
                                                ? "Yes"
                                                : "No"
                                            }
                                            onValueChanged={this.handleChangeDisallowPortal}
                                            layout="horizontal"
                                            disabled={!this.state.isEditMode}
                                        />
                                    </div>
                                </div>
                                {/* </>} */}
                            </div>
                            <div className="artist-profile__section-header mt-3">
                                <span className="font-size-one">Last Updated:&nbsp;{this.state.userCreatedDateTime}</span>
                            </div>
                            {this.state.IsShowError && this.state.errorMessage != null ? (
                                <span className="unscheduled-shift">
                                    <ul>
                                        {this.state.errorMessage.map((item: any, uniqueKey: number) => {
                                            return (
                                                <li key={uniqueKey}>
                                                    {item.columnName}: {item.errorMessage}
                                                </li>
                                            );
                                        })}
                                    </ul>
                                </span>
                            ) : null}
                        </div>
                    </div>
                    <div className="row mx-0 mb-3" hidden={!this.state.isEditMode}>
                        <div className="col-12 col-lg-12 row pr-0">
                            <div className="col-12 col-xl-2 pl-0">
                                <button
                                    className="btn btn--ghost btn--large"
                                    type="submit"
                                    onClick={(e: MouseEvent) => {
                                        e.preventDefault();
                                        this.handleCancelOnClick()
                                    }}
                                >
                                    Cancel
                                </button>
                            </div>
                            <div className="col-12 col-xl-2 pl-0 mt-3 mt-xl-0">
                                <button
                                    className="btn btn-primary btn--large"
                                    type="submit"
                                    onClick={(e: MouseEvent) => {
                                        e.preventDefault();
                                        this.onSubmit();
                                    }}
                                >
                                    Submit
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                
                
                <Popup
                    visible={this.state.showChangeEmailPopup}
                    onHiding={this.hideDetail}
                    dragEnabled={false}
                    hideOnOutsideClick={false}
                    showTitle={true}
                    showCloseButton={true}
                    title="CHANGE EMAIL"
                    width={"30%"}
                    height={"auto"}
                >
                    <ScrollView width="100%" height="100%">
                        <div>
                            <div className="text-center"><b>EXISTING EMAIL: {this.state.requestFormData.email}</b></div>
                            <div className="mt-3">Please enter new email here</div>
                            <div>
                                <TextBox
                                    width={"100%"}
                                    readOnly={false}
                                    onValueChanged={this.handleChangeNewEmail}
                                    valueChangeEvent="keyup"
                                    value={this.state.email}
                                />
                            </div>
                            <div className="text-center mt-3">This will take effect once you save the profile but contact IT before making this change as Azure needs to change first.</div>
                        </div>
                        <div className="text-center">
                            <button
                                className="btn btn-primary btn--large mt-3"
                                type="submit"
                                onClick={(e: MouseEvent) => {
                                    e.preventDefault();
                                    this.onConfirm();
                                }}
                            >
                                CONFIRM
                            </button>
                        </div>
                    </ScrollView>
                </Popup>
                <Popup
                    visible={this.state.showEmailValidationPopup}
                    onHiding={this.hideValidationDetail}
                    dragEnabled={false}
                    hideOnOutsideClick={false}
                    showTitle={true}
                    showCloseButton={true}
                    title="Error"
                    width={"30%"}
                    height={"auto"}
                >
                    <ScrollView width="100%" height="100%">
                        <div>
                            <div className="text-center font-size-one mt-3">Please enter a valid email first.</div>
                        </div>
                    </ScrollView>
                </Popup>

                <Popup
                    visible={this.state.yotiPopupVisible}
                    onHiding={() => this.setState((prevState: AddContactState) => ({
                        yotiPopupVisible: false,
                        yotiSessionStatus: prevState.yotiSessionStatus === 'Verifying...' ? 'Verify' : prevState.yotiSessionStatus,
                    }))}
                    dragEnabled={false}
                    hideOnOutsideClick={false}
                    showTitle={true}
                    showCloseButton={true}
                    title="Identity Verification"
                    width={"70%"}
                    height={"80%"}
                >
                    <ScrollView width="100%" height="100%">
                        <iframe
                            src={this.state.yotiUserViewUrl}
                            title="Yoti Identity Verification"
                            width="100%"
                            height="700px"
                            style={{ border: "none" }}
                            allow="camera; microphone; fullscreen; autoplay"
                        />
                    </ScrollView>
                </Popup>

                <Popup
                    visible={this.state.confirmActionPopupVisible}
                    onHiding={() => this.setState({ confirmActionPopupVisible: false })}
                    dragEnabled={false}
                    hideOnOutsideClick={false}
                    showTitle={true}
                    showCloseButton={true}
                    title="Confirm Action"
                    width={"40%"}
                    height={"auto"}
                >
                    <div className="d-flex flex-column" style={{ gap: "24px" }}>
                        <div style={{ border: "1px solid #d0d0d0", borderRadius: "8px", padding: "16px" }}>
                            <p className="mb-0" style={{ fontSize: "18px" }}>
                                Click on "View Yoti Session" to see results of existing ID checks or click on "New ID
                                Required" to trigger new ID request.
                            </p>
                        </div>
                        <div className="d-flex justify-content-end" style={{ gap: "12px" }}>
                            <button type="button" className="btn btn-primary btn--large" onClick={this.handleConfirmActionViewSession}>
                                <span>View Yoti Session</span>
                            </button>
                            <button type="button" className="btn btn-primary btn--large btn--reject" onClick={this.handleConfirmActionSetToRejected}>
                                <span>SET TO REJECTED</span>
                            </button>
                            <button type="button" className="btn btn--ghost btn--ghost--teal btn--large" onClick={this.handleConfirmActionNewIdRequired}>
                                <span>New ID Required</span>
                            </button>
                            <button type="button" className="btn btn--ghost btn--ghost--teal btn--large" onClick={() => this.setState({ confirmActionPopupVisible: false })}>
                                <span>Close</span>
                            </button>
                        </div>
                    </div>
                </Popup>

                <Popup
                    visible={this.state.notepadPopupVisible}
                    onHiding={() => this.setState({ notepadPopupVisible: false })}
                    dragEnabled={false}
                    hideOnOutsideClick={false}
                    showTitle={true}
                    showCloseButton={true}
                    title="Session Review"
                    className="pop-up pop-up--left-aligned artist-profile__verification-popup"
                    width={"95%"}
                    height={"80%"}
                >
                    <ScrollView width="100%" height="100%">
                        <IdVerificationSessionReviewPopupContent
                            idVerificationSessions={this.state.idVerificationSessions}
                            selectedIdVerificationSessionId={this.state.selectedIdVerificationSessionId}
                            selectedIdVerificationSession={
                                this.state.idVerificationSessions.find(
                                    (s: any) => s.draftVerificationSessionId === this.state.selectedIdVerificationSessionId
                                ) || this.state.idVerificationSessions[0]
                            }
                            selectedVerificationDecision={this.state.selectedVerificationDecision}
                            selectedVerificationReviewerNotes={this.state.selectedVerificationReviewerNotes}
                            selectedVerificationIsActive={this.state.selectedVerificationIsActive}
                            onSessionSelectionChanged={this.handleIdVerificationSessionSelectionChanged}
                            onSessionExporting={this.onIdVerificationSessionsExporting}
                            onDecisionChange={(selectedVerificationDecision) => this.setState({ selectedVerificationDecision })}
                            onReviewerNotesChange={(selectedVerificationReviewerNotes) => this.setState({ selectedVerificationReviewerNotes })}
                            onActiveStatusChange={(selectedVerificationIsActive) => this.setState({ selectedVerificationIsActive })}
                            onApply={this.handleVerificationApply}
                            formatSessionReviewDateTime={this.formatSessionReviewDateTime}
                            getSessionReviewPillCssModifier={this.getSessionReviewPillCssModifier}
                            getSessionReviewHeaderStatus={this.getSessionReviewHeaderStatus}
                            getSessionReviewStateClass={this.getSessionReviewStateClass}
                            getSessionReviewState={this.getSessionReviewState}
                            getVerificationPillCssModifier={this.getVerificationPillCssModifier}
                        />
                    </ScrollView>
                </Popup>
            </div >
        );
    }
}
export default withTranslation()(AddContact);
